/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_TitleInputs */

const en_csv_to_json_title = /** @type {(inputs: Csv_To_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV to JSON Converter`)
};

const ko_csv_to_json_title = /** @type {(inputs: Csv_To_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV → JSON 변환기`)
};

const ja_csv_to_json_title = /** @type {(inputs: Csv_To_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV → JSON変換ツール`)
};

/**
* | output |
* | --- |
* | "CSV to JSON Converter" |
*
* @param {Csv_To_Json_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_title = /** @type {((inputs?: Csv_To_Json_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_title(inputs)
	if (locale === "ko") return ko_csv_to_json_title(inputs)
	return ja_csv_to_json_title(inputs)
});